import * as React from 'react';
import * as routes from '../../routes';
import { Link, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import {
  LinkedinIcon,
  GithubIcon,
  // MenuIcon,
  SunIcon,
  MoonIcon,
  InstagramIcon,
  TwitterIcon,
  DribbleIcon,
} from '../icons';
import Footer from '../common/Footer';
import GetInTouchBanner from '../common/GetInTouchBanner';

const Topbar = styled.div`
  max-width: ${(props) => props.theme.container.maxWidth};
  margin: auto;
  padding: 10px 32px;
  width: 100%;
  @media (max-width: 768px) {
    width: auto;
    margin: unset;
  }
  ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
  }
`;
const MainMenu = styled.div`
  a {
    margin-right: 20px;
    margin-left: 20px;
  }
  .hidden {
    @media (max-width: 768px) {
      display: none;
    }
  }
`;

const Logo = styled(Link)`
  p {
    font-weight: bold;
  }
`;

const RightMenu = styled.div`
  display: flex;
  align-items: center;
  a {
    display: flex;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const SocialMedia = styled.div`
  display: flex;
  align-items: center;
  a {
    margin-right: 15px;
    margin-left: 8px;
  }
`;

const Button = styled.div`
  background: none;
  border: 0;
  cursor: pointer;
`;

// const HamburguerMenu = styled(Button)`
//   margin-left: 30px;
//   display: flex;
// `;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Content = styled.div`
  padding: 0 32px;
`;
const WrapperContent = styled.div`
  max-width: ${(props) => props.theme.container.maxWidth};
  width: 100%;
  margin: auto;
`;
const StyledLink = styled(Link)`
  color: ${(props) =>
    props.isActive ? props.theme.palette.primary.main : props.theme.palette.text.primary};
`;

function ThemeIcon() {
  const [theme, setTheme] = React.useState(true);
  return (
    <Button
      style={{ marginLeft: '24px', display: 'flex' }}
      type="button"
      onClick={() => setTheme(!theme)}
    >
      {theme ? <SunIcon /> : <MoonIcon />}
    </Button>
  );
}

function Social({ footer }) {
  return (
    <SocialMedia>
      <a href="https://www.linkedin.com/in/paulccari/" target="_blank" rel="noreferrer">
        <LinkedinIcon />
      </a>
      <a href="https://github.com/paulclindo" target="_blank" rel="noreferrer">
        <GithubIcon />
      </a>
      {footer ? (
        <>
          <a href="https://www.instagram.com/in/paulccari/" target="_blank" rel="noreferrer">
            <InstagramIcon />
          </a>
          <a href="https://twitter.com/paulclindo" target="_blank" rel="noreferrer">
            <TwitterIcon />
          </a>
          <a href="https://dribbble.com/paulclindo" target="_blank" rel="noreferrer">
            <DribbleIcon />
          </a>
        </>
      ) : null}
    </SocialMedia>
  );
}

function NavLink(props) {
  const match = useRouteMatch(props.to);
  return <StyledLink isActive={match} {...props} />;
}

function TopMenu() {
  return (
    <Topbar>
      <ul>
        <Logo to={routes.home}>
          <p>PAUL CCARI.</p>
        </Logo>
        <MainMenu>
          <NavLink to={routes.work}>Work</NavLink>
          <NavLink to={routes.blog}>Blog</NavLink>
          <NavLink to={routes.about} className="hidden">
            About
          </NavLink>
          <a href="mailto:paulclindo@gmail.com" target="_blank" rel="noreferrer">
            Contact
          </a>
        </MainMenu>
        <RightMenu>
          <Social />
          <ThemeIcon />
          {/* <HamburguerMenu>
            <MenuIcon />
          </HamburguerMenu> */}
        </RightMenu>
      </ul>
    </Topbar>
  );
}

function MainLayout({ children }) {
  return (
    <Wrapper>
      <TopMenu />
      <WrapperContent>
        <Content>{children}</Content>
      </WrapperContent>
      <GetInTouchBanner />
      <Footer />
    </Wrapper>
  );
}

export { Social, MainLayout };
